import { parse } from '@config/theme';
export const content = parse({
  display: 'block',
  width: '100%'
}, "cjexru4");
export const container = "c1h1u4zu";

require("./styles.linaria.module.css!=!../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");